import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../model/dto/user';
import { UserService } from './user.service';

export interface IAuthenticationResult {
  IsAuthenticated: boolean;
  ErrorMessage: string;
}

@Injectable()
export class AuthService {

  constructor(
    private userService: UserService,
    private router: Router
  ) {}

  private successAuthResult = <IAuthenticationResult>{ ErrorMessage: null, IsAuthenticated: true };
  private failedAuthResult = <IAuthenticationResult>{ ErrorMessage: null, IsAuthenticated: false };
  
   public async login(username:string, password:string){
     console.log("222222222222222");
    let promise = await new Promise(async (resolve, reject) => {
      await this.userService.login(username, password)
        .then(
          res => { // Success
            console.log("666666666666666");
          resolve(true);
          },
          msg => { // Error
            console.log("nope");
          reject(false);
          }
        );
        console.log("nope");
    });

    console.log("666666666666666.6666666666666666666");
    return promise;
    
    
  } 

  logout() {                            // {4}
    localStorage.removeItem('userToken');
    localStorage.removeItem('userRoles');
    this.router.navigate(['/login']);
  }

  public resetPassword(): void {
    //todo
  }
  
  public getLoggedInUser(): User {
    return this.userService.getCurrentUser();
  }

  public getRoleMatch(allowedRoles): any {
    return this.userService.roleMatch(allowedRoles);
  }

  public setNavigationRoles(): any {
    return this.userService.setNavigationRoles();
  }

  public isAuthenticated(): any {
    return this.userService.isAuthenticated();
  }
}